<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      v-model="email"
      :rules="emailRules"
      label="E-mail"
      type="email"
      required
    />

    <v-text-field
      v-model="password"
      :rules="passwordRules"
      label="Password"
      type="password"
      required
    />

    <v-layout py-2>
      <v-flex class="text-xs-right">
        <v-spacer />
        <v-btn
          flat
        >
          Forget Password
        </v-btn>
        <v-btn
          :disabled="!valid"
          :loading="isLoading"
          color="info"
          @click.stop="validate"
        >
          Sign In
        </v-btn>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { authLogin } from '../../../helpers/authentication'
export default {
  data: () => ({
    valid: true,
    email: '',
    emailRules: [
      value => !!value || 'E-mail is required',
      value => /.+@.+/.test(value) || 'E-mail must be valid'
    ],
    password: '',
    passwordRules: [
      value => !!value || 'Password is required',
      value => (value && value.length >= 8) || 'Password must be more than 8 characters'
    ],
  }),
  computed: {
    ...mapGetters({
      isLoading: 'auth/isLoading'
    })
  },
  methods: {
    ...mapActions({
      setErrors: 'auth/setErrors',
      setLoading: 'auth/setLoading',
      login: 'auth/login',
      loginFailed: 'auth/LoginFailed'
    }),
    validate () {
      if (this.$refs.form.validate()) {
        this.setErrors(null)
        this.setLoading(true)
        authLogin({
          email: this.email,
          password: this.password
        }).then((response) => {
          this.login(response.data)
          .then(() => {
            this.setLoading(false)
            this.$router.go({ name: 'dashboard' })
          })
        }).catch((response) => {
          this.setErrors(response)
          this.setLoading(false)
        })
      }
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    }
  }
}
</script>
